import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import FORMATS from '../utils/formats';

function InputCreditCardExpireTime(props) {
  const { name, inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format={FORMATS.CREDIT_CARD_EXPIRE_TIME}
      getInputRef={inputRef}
      isNumericString
      mask={['M', 'M', 'Y', 'Y']}
      placeholder="MM/YY"
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
    />
  );
}

InputCreditCardExpireTime.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
};

export default InputCreditCardExpireTime;
